var map = {
	"./WELEDA_Logo_2024_SC_PMS_Light_Vivid_Green.eps": 33,
	"./cz": 14,
	"./cz.png": 14,
	"./czech-republic": 15,
	"./czech-republic.svg": 15,
	"./en": 16,
	"./en.png": 16,
	"./packshot_image_background": 17,
	"./packshot_image_background.png": 17,
	"./placeholder_image": 18,
	"./placeholder_image.png": 18,
	"./polish": 19,
	"./polish.png": 19,
	"./slovakia": 20,
	"./slovakia.svg": 20,
	"./sort": 21,
	"./sort.png": 21,
	"./weleda_logo": 22,
	"./weleda_logo.pdf": 34,
	"./weleda_logo.png": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;